class CollapsibleHeader extends Collapsible {
  constructor() {
    super()

    this.header = this.closest('[data-header]')
    this.headerWrapper = this.closest('#shopify-section-header')
    if (this.header) {
      this.shadow = this.header.querySelector('.header-shadow')

      // extra events
      this.shadow?.addEventListener('click', this.closeAll.bind(this))
    }
  }

  events() {
    if (!this.header) {
      super.events()
    }
  }

  open(group) {
    super.open(group)

    // Close any search dropdowns if opened
    if (this.header.classList.contains('header--search-active')) {
      this.header.classList.remove('header--search-active')
    }

    // Set initial classes
    if (this.options.initialOpenState && group.classList.contains('header__menu-item--level-1')) {
      this.setInitialToggleClasses()
    }

    let overlay
    if (group.classList.contains('header__menu-item--level-1')) {
      overlay = group.querySelector('[data-collapsible-target="level-1"]')
    } else {
      overlay = group.closest('[data-collapsible-target="level-1"]')
    }

    // Set level-3 toggle classes
    if (group.classList.contains('header__menu-item--level-2')) {
      group.querySelectorAll('[data-collapsible-group="level-3"]').forEach((groupLevel2) => {
        groupLevel2?.classList.remove(`${this.options.toggleClass}`)
      })
      group.querySelectorAll('[data-collapsible-group="level-3"]')[0]?.classList.add(`${this.options.toggleClass}`)
    }

    // Set min height to overlay based on active level 2 item
    let target
    let level2TargetHeight = 0
    if (overlay) {
      overlay.style.minHeight = '0px'
    }

    if (
      group.querySelector('[data-collapsible-group="level-2"][data-initial-active="true"]') &&
      group.querySelector('[data-collapsible-group="level-3"][data-initial-active="true"]')?.classList.contains(`${this.options.toggleClass}`)
    ) {
      target = group.querySelector('[data-collapsible-group="level-3"][data-initial-active="true"] [data-collapsible-target]')
      level2TargetHeight = group.querySelector('[data-collapsible-group="level-2"][data-initial-active="true"] [data-collapsible-target="level-2"]').scrollHeight || 0
    } else {
      target = group.querySelector('[data-collapsible-target]')
      level2TargetHeight =
        group.closest('[data-collapsible-target="level-1"]')?.querySelector('[data-collapsible-group="level-2"].header__menu-item--is-open [data-collapsible-target="level-2"]')
          .scrollHeight || 0
    }

    if (overlay) {
      if (target) {
        if (level2TargetHeight > target.offsetHeight) {
          overlay.style.minHeight = `${level2TargetHeight}px`
        } else {
          overlay.style.minHeight = `${target.offsetHeight}px`
        }
      } else {
        overlay.style.minHeight = `${level2TargetHeight}px`
      }
    }

    if (this.headerWrapper && this.classList.contains('header__secondary-menu') === false) {
      this.headerWrapper.classList.add('shopify-section-header--open')
    }
    this.toggleHeaderClass(true)
  }

  close(group) {
    super.close(group)
    this.toggleHeaderClass(false)
  }

  closeSiblings(currentGroup = null) {
    super.closeSiblings(currentGroup)
    this.toggleHeaderClass(false)
  }

  openAll() {
    super.openAll()
    this.toggleHeaderClass(true)
  }

  closeAll() {
    super.closeAll()
    this.toggleHeaderClass(false)
    if (this.headerWrapper && this.classList.contains('header__secondary-menu') === false) {
      this.headerWrapper.classList.remove('shopify-section-header--open')
      this.header.classList.remove('header--is-open')
    }
    if (this.options.initialOpenState) {
      this.setInitialToggleClasses()
    }
  }

  setInitialToggleClasses() {
    const groupsLevel1 = this.querySelectorAll('[data-collapsible-group="level-1"]')

    groupsLevel1.forEach((groupLevel1) => {
      groupLevel1.querySelectorAll('[data-collapsible-group="level-2"]').forEach((groupLevel2) => {
        groupLevel2.classList.remove(`${this.options.toggleClass}`)
      })
      groupLevel1.querySelectorAll('[data-collapsible-group="level-3"]').forEach((groupLevel3) => {
        groupLevel3.classList.remove(`${this.options.toggleClass}`)
      })
      groupLevel1.querySelector('[data-collapsible-group="level-2"][data-initial-active="true"]').classList.add(`${this.options.toggleClass}`)
      groupLevel1.querySelector('[data-collapsible-group="level-3"][data-initial-active="true"]').classList.add(`${this.options.toggleClass}`)
    })
  }

  toggleHeaderClass(open = true) {
    if (!this.header) {
      return false
    }

    if (open) {
      // set header open
      if (this.classList.contains('header__secondary-menu') === false) {
        this.header.classList.add('header--is-open')
      }
    } else {
      // set header closed if all menu items are closed
      let close = true
      this.groups.forEach((group) => {
        if (group.classList.contains(this.options.toggleClass)) {
          close = false
        }
      })
      if (close) {
        if (this.classList.contains('header__secondary-menu') === false) {
          this.header.classList.remove('header--is-open')
        }
      }
    }
  }
}

class CollapsibleMobileHeader extends Collapsible {
  constructor() {
    super()

    // Options
    this.options = {
      toggleClass: 'collapsible-is-open',
      toggleBodyClass: '',
      closeSiblings: false,
      closeChildren: true,
      onHover: false,
      hoverDelay: 0,
      closeOnMouseleave: false,
      initialOpenState: false,
      scrollIntoView: false,
      isAnimated: false,
      isAnimatedClass: 'collapsible--is-animated',
    }

    // Get options from element data and combine with this.options
    if (this?.dataset?.options) {
      const dataOptions = JSON.parse(this.dataset.options)
      this.options = {
        ...this.options,
        ...dataOptions,
      }
    }

    this.menuDrawer = this.closest('[data-menu-drawer]')
  }

  open(group) {
    super.open(group)

    const scrollIntoViewClass = 'collapsible-scrollintoview'
    const scrollTopClass = 'collapsible-scrolltop'

    // If scroll top
    if (group.classList.contains(scrollTopClass)) {
      this.menuDrawer.scrollTop = 0
    }

    // If animated
    if (this.options.isAnimated && group.classList.contains(this.options.isAnimatedClass)) {
      const groupTargetContainer = group.querySelector('[data-collapsible-target]')

      groupTargetContainer.style.height = 'auto'
      const height = `${groupTargetContainer.clientHeight}px`

      groupTargetContainer.style.height = 0
      setTimeout(function () {
        groupTargetContainer.style.height = height
      }, 0)

      // If both animated and scroll into view
      if (this.options.scrollIntoView && group.classList.contains(scrollIntoViewClass)) {
        let intervalId

        const nextGroup = group.nextElementSibling?.hasAttribute('data-collapsible-group') ? group.nextElementSibling : null

        groupTargetContainer.addEventListener(
          'transitionstart',
          function () {
            intervalId = setInterval(() => {
              group.scrollIntoView({ block: 'nearest', behavior: 'smooth' })

              if (nextGroup) {
                nextGroup.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
              }
            }, 25)
          },
          {
            once: true,
          },
        )

        groupTargetContainer.addEventListener(
          'transitionend',
          function () {
            clearInterval(intervalId)
            intervalId = null
          },
          {
            once: true,
          },
        )
      }

      // If only scroll into view
    } else if (this.options.scrollIntoView && group.classList.contains(scrollIntoViewClass)) {
      group.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
    }
  }

  close(group) {
    super.close(group)

    // Close active group
    if (this.options.isAnimated && group.classList.contains(this.options.isAnimatedClass)) {
      // If animated
      const groupTargetContainer = group.querySelector('[data-collapsible-target]')
      const toggleClass = this.options.toggleClass
      groupTargetContainer.style.height = 0
      group.classList.remove(toggleClass)
    } else {
      group.classList.remove(this.options.toggleClass)
    }
  }

  closeAll() {
    super.closeAll()
  }
}

class ToggleMobileNavigation extends ToggleElementClass {
  constructor() {
    super()
    this.body = this.closest('body')
    this.header = this.closest('[data-header]')
    this.headerWrapper = this.closest('#shopify-section-header')

    if (this.header) {
      this.inverse = !!this.header.classList.contains('header--inverse')
      this.shadow = this.header.querySelector('.header-shadow')

      // Set the header bottom position
      this.setHeaderWrapperBottomProperty()

      window.addEventListener(
        'resize',
        debounce(() => {
          this.setViewportHeight()
        }, 100).bind(this),
      )

      // extra events
      document.addEventListener('keyup', this.onKeyUp.bind(this))
      this.shadow?.addEventListener('click', this.remove.bind(this))
    }
  }

  events() {
    if (!this.header) {
      super.events()
    }
  }

  setHeaderWrapperBottomProperty() {
    const boundingClientRect = this.header.getBoundingClientRect()
    const headerWrapperBottom = boundingClientRect.bottom.toString()
    document.documentElement.style.setProperty('--header-bottom-position', `${headerWrapperBottom}px`)
  }

  setViewportHeight() {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
  }

  onKeyUp(event) {
    if (!this.header.classList.contains('header--is-open') && !this.header.classList.contains('header--search-active')) {
      return
    }
    if (event?.code.toUpperCase() !== 'ESCAPE') {
      return
    }

    if (this.header.classList.contains('header--is-open')) {
      const { toggleClass } = this.options
      if (this.target?.classList.contains(toggleClass)) {
        this.remove()
      }
    }

    if (this.header.classList.contains('header--search-active')) {
      this.header.classList.remove('header--search-active')
    }
  }

  add() {
    super.add()

    this.setHeaderWrapperBottomProperty()
    this.setViewportHeight()

    if (this.header) {
      this.header.classList.add('header--is-open')
    }
    if (this.headerWrapper) {
      this.headerWrapper.classList.add('shopify-section-header--open')
    }
    this.body.classList.add('menu-drawer--is-open')
    trapFocus(this.header)

    this.ariaExpanded = true
  }

  remove() {
    super.remove()
    if (this.header) {
      this.header.classList.remove('header--is-open')
    }
    if (this.headerWrapper) {
      this.headerWrapper.classList.remove('shopify-section-header--open')
    }
    this.body.classList.remove('menu-drawer--is-open')
    this.closeAllSibblings()
    removeTrapFocus()

    this.ariaExpanded = false
  }

  closeAllSibblings() {
    const collapsibles = this.target.querySelector('collapsible-mobile-header')
    collapsibles.closeAll()
  }
}

if (!customElements.get('collapsible-header')) {
  customElements.define('collapsible-header', CollapsibleHeader)
}

if (!customElements.get('collapsible-mobile-header')) {
  customElements.define('collapsible-mobile-header', CollapsibleMobileHeader)
}

if (!customElements.get('toggle-mobile-navigation')) {
  customElements.define('toggle-mobile-navigation', ToggleMobileNavigation)
}
